export enum OnyxTheme {
  LIGHT = 'light',
  DARK = 'dark',
}
